import {array, boolean, object, string} from 'yup';

import {paginationV8nSchema} from '@shared/api';
import {
  localizedTextOptionalNullable,
  localizedTextRequired,
} from '@shared/utils';
import {EventTemplateType} from '../types';

export const currencyV8nSchema = object().shape({
  id: string().required(),
  slug: string().required(),
  coingecko_id: string().required(),
  coingecko_network: string().required(),
  coingecko_token_address: string().required(),
  is_active: boolean().required(),
});

export const v8nSchemaOfGetCurrenciesResponse = array().of(currencyV8nSchema);

export const v8nSchemaOfGetPaymentCurrenciesResponse = object().shape({
  array: array().of(string().required()).required(),
});

export const currencyEventScheduleV8nSchema = object().shape({
  id: string().required(),
  currency_id: string().required(),
  currency_slug: string().required(),
  template_id: string().required(),
  template_type: string().oneOf(Object.values(EventTemplateType)).required(),
  cron: string().required(),
  next_run_at: string().required(),
});

export const v8nSchemaOfGetCurrencyEventSchedulesResponse =
  paginationV8nSchema.shape({
    array: array().of(currencyEventScheduleV8nSchema),
  });

export const eventTemplateV8nSchema = object().shape({
  id: string().required(),
  type: string().oneOf(Object.values(EventTemplateType)).required(),
  templates: object().shape({
    name: localizedTextRequired,
    short_name: localizedTextOptionalNullable,
  }),
});

export const v8nSchemaOfGetEventTemplatesResponse = array().of(
  eventTemplateV8nSchema,
);
